var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Panel',{attrs:{"module":"Faturamento","title":"Gerar Faturamento","showFilter":false,"showSearch":false,"showButtons":false}},[_c('div',{attrs:{"slot":"content-main"},slot:"content-main"},[_c('GenerateBilling')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }